module.exports = __webpack_public_path__ + "img/sintesis.27b7e2f4.svg";